import EventDescription from "../components/EventDescription";
import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import * as API from "../services/API";
import HeaderMembers from "../headers/headerMembers";
import Footer from "../components/Footer";
import "../css/EventCard.css";
import "../css/EventTimeline.css";
import HeaderHome from "../headers/headerHome";
import { useLocation } from "react-router-dom";

// --------- Event Card ---------

function EventCard({ event, onSelect }) {
  return (
    <div
      className="event-card card border-0 shadow h-100"
      onClick={() => onSelect(event)}
    >
      <div className="event-image-wrapper">
        <img src={event.image} alt={event.title} className="event-image" />
        <span className="event-date">
          {new Date(event.start_date).toLocaleDateString("fr-FR")}
        </span>
      </div>

      <div className="card-body d-flex flex-column">
        <h5 className="card-title mb-2">{event.title}</h5>

        <EventDescription className="card-text text-muted flex-grow-1" value={event.description_internal || event.description_general} />
        
        <span className="event-cta mt-3">
          Voir les détails →
        </span>
      </div>
    </div>
  );
}

// --------- Event Modal ---------

function EventModal({ event, onClose }) {
  if (!event) return null;

  return (
    <Modal show onHide={onClose} centered  size="xl" dialogClassName="event-modal-dialog" contentClassName="event-modal-content">
      <button className="event-modal-close" onClick={onClose}>✕</button>
      <div className="event-modal-hero">
        <img src={event.image} alt={event.title} />
        <div className="event-modal-hero-overlay">
          <h2>{event.title}</h2>
          <span>
            📅 {new Date(event.start_date).toLocaleDateString("fr-FR")}
          </span>
        </div>
      </div>

      <div className="event-modal-body">
          <EventDescription className="card-text text-muted flex-grow-1" value={event.description_internal || event.description_general} />
        
      </div>

      <div className="event-modal-footer">
        <Button variant="outline-secondary" onClick={onClose}>
          Fermer
        </Button>
      </div>
    </Modal>
  );
}

// --------- Page ---------

export default function EventsPage() {
  const location = useLocation();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [events, setEvents] = useState([]);
  const searchParams = new URLSearchParams(location.search);
  const eventIdFromUrl = searchParams.get("eventid");
  useEffect(() => {
    API.getEvenementExternalRequest(
      (response) => {
        setEvents(response.data);
        if (eventIdFromUrl) {
          const eventToOpen = response.data.find(
            (e) => e.id?.toString() === eventIdFromUrl || e._id?.toString() === eventIdFromUrl
          );
          if (eventToOpen) setSelectedEvent(eventToOpen);
        }
      },
      () => {}
    );
  }, []);

  // const now = new Date();

  // // ÉVÈNEMENTS À VENIR
  // const futureEvents = events
  //   .filter(e => new Date(e.start_date) >= now)
  //   .sort((a, b) => new Date(a.start_date) - new Date(b.start_date));

  // // ÉVÈNEMENTS PASSÉS
  // const pastEvents = events
  //   .filter(e => new Date(e.start_date) < now)
  //   .sort((a, b) => new Date(b.start_date) - new Date(a.start_date));

  // REGROUPEMENT PAR ANNÉE
  const pastEventsByYear = events.reduce((acc, event) => {
    const year = new Date(event.start_date).getFullYear();
    if (!acc[year]) acc[year] = [];
    acc[year].push(event);
    return acc;
  }, {});

  // TRI PAR DATE DÉCROISSANTE AU SEIN DE CHAQUE ANNÉE
  Object.values(pastEventsByYear).forEach(yearEvents => {
    yearEvents.sort((a, b) => new Date(b.start_date) - new Date(a.start_date));
  });

  const sortedYears = Object.keys(pastEventsByYear)
    .sort((a, b) => b - a);

  return (
    <>
      <HeaderHome />

      <div className="min-vh-100 bg-light bg-gradient">
        <div className="container py-5">

          {/* PASSÉS – TIMELINE */}
          <h1 className="text-center my-5 text-dark">
            Que se passe-t-il ailleurs?
          </h1>

          <div className="timeline">
            {sortedYears.map(year => (
              <div key={year} className="timeline-year">
                <div className="timeline-year-label">{year}</div>

                {pastEventsByYear[year].map(event => (
                  <div key={event.id} className="timeline-item">
                    <div className="timeline-dot" />
                    <div className="timeline-content">
                      <EventCard
                        event={event}
                        onSelect={setSelectedEvent}
                      />
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>

        </div>
      </div>

      <Footer />

      <EventModal
        event={selectedEvent}
        onClose={() => setSelectedEvent(null)}
      />
    </>
  );
}
